import { useId, type ReactNode } from "react";
import { PixelGateScene, type PixelGateItem } from "./PixelGateScene";

export type PageStateKind = "denied" | "not-found" | "error" | "coming-soon";

const COPY: Record<PageStateKind, { label: string; title: string; item: PixelGateItem }> = {
  denied: { label: "접근 권한 안내", title: "앗! 여기는 보리가 지키고 있어요", item: "lock" },
  "not-found": { label: "페이지 안내", title: "앗! 여기에 찾는 페이지가 없어요", item: "paper" },
  error: { label: "오류 안내", title: "앗! 잠시 멈췄어요", item: "paper" },
  "coming-soon": { label: "준비 중", title: "아직 문을 열 준비 중이에요", item: "lock" },
};

/** 권한·페이지 오류 공용 표시. 이동과 재시도는 호출부에서 연결한다. */
export function PageState({ kind, description, actionLabel, onAction, secondaryAction }: {
  kind: PageStateKind;
  description: ReactNode;
  actionLabel: string;
  onAction: () => void;
  secondaryAction?: ReactNode;
}) {
  const titleId = useId();
  const copy = COPY[kind];
  return (
    <section className="page-state" aria-labelledby={titleId}>
      <div className="page-state-inner">
        <div className="page-state-scene"><PixelGateScene item={copy.item} /></div>
        <div className="page-state-label">{copy.label}</div>
        <h1 id={titleId} className="page-state-title">{copy.title}</h1>
        <div className="page-state-description">{description}</div>
        <div className="page-state-actions">
          {secondaryAction}
          <button type="button" className="btn-primary" onClick={onAction}>{actionLabel}</button>
        </div>
      </div>
    </section>
  );
}
